import React from 'react';

const MessagingTab = ({
  messagingForm,
  setMessagingForm,
  loading,
  emailHeaderFile,
  emailSignatureFile,
  handleSaveMessaging,
  handleEmailHeaderFileChange,
  handleEmailSignatureFileChange,
}) => {
  return (
    <div className="card">
      <h2 className="text-xl font-bold mb-4">Mensajes SMS / WhatsApp</h2>
      <p className="text-gray-600 mb-6">
        Configura mensajes automáticos enviados por SMS o WhatsApp a tus asistentes
      </p>

      <form onSubmit={handleSaveMessaging} className="space-y-6">
        {/* Mensaje de Bienvenida */}
        <div className="border-b border-gray-200 pb-6">
          <h3 className="text-lg font-semibold mb-4">Mensaje de Bienvenida</h3>
          <p className="text-sm text-gray-600 mb-4">
            Este mensaje se envía automáticamente cuando un asistente se registra
          </p>

          <div className="space-y-4">
            <div>
              <label className="flex items-center mb-3">
                <input
                  type="checkbox"
                  checked={messagingForm.welcomeMessageEnabled}
                  onChange={(e) => setMessagingForm({...messagingForm, welcomeMessageEnabled: e.target.checked})}
                  className="mr-2 h-4 w-4"
                />
                <span className="font-medium">Habilitar mensaje de bienvenida</span>
              </label>
            </div>

            <div>
              <label className="label">Mensaje</label>
              <textarea
                value={messagingForm.welcomeMessage}
                onChange={(e) => setMessagingForm({...messagingForm, welcomeMessage: e.target.value})}
                className="input-field"
                rows="4"
                placeholder="Hola {name}, gracias por registrarte para {project}! Tu codigo QR es: {qr}"
                disabled={!messagingForm.welcomeMessageEnabled}
              />
              <p className="text-sm text-gray-500 mt-1">
                Variables disponibles: {'{name}'}, {'{project}'}, {'{qr}'}
              </p>
            </div>
          </div>
        </div>

        {/* Mensaje de Recordatorio */}
        <div className="border-b border-gray-200 pb-6">
          <h3 className="text-lg font-semibold mb-4">Mensaje de Recordatorio</h3>
          <p className="text-sm text-gray-600 mb-4">
            Este mensaje se envía manualmente a todos los asistentes registrados
          </p>

          <div className="space-y-4">
            <div>
              <label className="flex items-center mb-3">
                <input
                  type="checkbox"
                  checked={messagingForm.reminderMessageEnabled}
                  onChange={(e) => setMessagingForm({...messagingForm, reminderMessageEnabled: e.target.checked})}
                  className="mr-2 h-4 w-4"
                />
                <span className="font-medium">Habilitar mensaje de recordatorio</span>
              </label>
            </div>

            <div>
              <label className="label">Mensaje</label>
              <textarea
                value={messagingForm.reminderMessage}
                onChange={(e) => setMessagingForm({...messagingForm, reminderMessage: e.target.value})}
                className="input-field"
                rows="4"
                placeholder="Hola {name}, te recordamos que {project} sera manana. No olvides tu codigo QR: {qr}!"
                disabled={!messagingForm.reminderMessageEnabled}
              />
              <p className="text-sm text-gray-500 mt-1">
                Variables disponibles: {'{name}'}, {'{project}'}, {'{qr}'}
              </p>
            </div>
          </div>
        </div>

        {/* Configuración de Envío */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Configuracion de Envio</h3>
          <div className="space-y-4">
            <div className="flex items-center space-x-6">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={messagingForm.sendViaSms}
                  onChange={(e) => setMessagingForm({...messagingForm, sendViaSms: e.target.checked})}
                  className="mr-2 h-4 w-4"
                />
                <span>Enviar por SMS</span>
              </label>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={messagingForm.sendViaWhatsapp}
                  onChange={(e) => setMessagingForm({...messagingForm, sendViaWhatsapp: e.target.checked})}
                  className="mr-2 h-4 w-4"
                />
                <span>Enviar por WhatsApp</span>
              </label>
            </div>

            <div>
              <label className="label">Campo de telefono a usar</label>
              <input
                type="text"
                value={messagingForm.phoneFieldName}
                onChange={(e) => setMessagingForm({...messagingForm, phoneFieldName: e.target.value})}
                className="input-field"
                placeholder="phone"
              />
              <p className="text-sm text-gray-500 mt-1">
                Nombre del campo de telefono en tu formulario (generalmente "phone")
              </p>
            </div>
          </div>
        </div>

        {/* Configuración de Correo Electrónico */}
        <div className="border-t border-gray-200 pt-6">
          <h3 className="text-lg font-semibold mb-4">Configuracion de Correo Electronico</h3>
          <p className="text-sm text-gray-600 mb-4">
            Configura el correo que se envia automaticamente al registrarse con el link del codigo QR
          </p>

          <div className="space-y-4">
            <div>
              <label className="flex items-center mb-3">
                <input
                  type="checkbox"
                  checked={messagingForm.emailEnabled}
                  onChange={(e) => setMessagingForm({...messagingForm, emailEnabled: e.target.checked})}
                  className="mr-2 h-4 w-4"
                />
                <span className="font-medium">Enviar correo electronico al registrarse</span>
              </label>
            </div>

            <div>
              <label className="label">Asunto del correo</label>
              <input
                type="text"
                value={messagingForm.emailSubject}
                onChange={(e) => setMessagingForm({...messagingForm, emailSubject: e.target.value})}
                className="input-field"
                placeholder="Tu acceso para {project}"
                disabled={!messagingForm.emailEnabled}
              />
              <p className="text-sm text-gray-500 mt-1">
                Variables disponibles: {'{name}'}, {'{project}'}
              </p>
            </div>

            <div>
              <label className="label">Mensaje del correo</label>
              <textarea
                value={messagingForm.emailMessage}
                onChange={(e) => setMessagingForm({...messagingForm, emailMessage: e.target.value})}
                className="input-field"
                rows="6"
                placeholder="Hola {name}, adjuntamos tu pase de acceso para {project}. Haz clic en el siguiente enlace para ver tu codigo QR: {qr_link}"
                disabled={!messagingForm.emailEnabled}
              />
              <p className="text-sm text-gray-500 mt-1">
                Variables disponibles: {'{name}'}, {'{project}'}, {'{qr}'}, {'{qr_link}'} (enlace a la imagen del QR)
              </p>
            </div>

            {/* Diseño Personalizado del Email */}
            <div className="border-t border-gray-200 pt-4 mt-4">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h4 className="text-md font-semibold">Diseno Personalizado</h4>
                  <p className="text-sm text-gray-600 mt-1">
                    Personaliza el aspecto visual del correo electronico
                  </p>
                </div>
                <label className="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={messagingForm.emailUseCustomDesign}
                    onChange={(e) => setMessagingForm({...messagingForm, emailUseCustomDesign: e.target.checked})}
                    className="mr-2 h-4 w-4"
                    disabled={!messagingForm.emailEnabled}
                  />
                  <span className="text-sm font-medium">Activar diseno personalizado</span>
                </label>
              </div>

              {messagingForm.emailUseCustomDesign && messagingForm.emailEnabled && (
                <div className="space-y-4 pl-4 border-l-4 border-blue-200">
                  {/* Imagen de cabecera */}
                  <div>
                    <label className="label">Imagen de Cabecera</label>
                    <p className="text-sm text-gray-600 mb-2">
                      Sube una imagen que aparecera en la parte superior del correo (Recomendado: 600x200px, maximo 5MB)
                    </p>

                    {messagingForm.emailHeaderImage && !emailHeaderFile && (
                      <div className="mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-700 mb-2">Imagen actual:</p>
                        <img
                          src={messagingForm.emailHeaderImage}
                          alt="Cabecera actual"
                          className="max-w-full h-auto rounded border border-gray-300"
                          style={{ maxHeight: '150px' }}
                        />
                      </div>
                    )}

                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleEmailHeaderFileChange}
                      className="input-field"
                    />

                    {emailHeaderFile && (
                      <p className="text-sm text-green-600 mt-1">
                        Nueva imagen seleccionada: {emailHeaderFile.name}
                      </p>
                    )}

                    <p className="text-sm text-gray-500 mt-1">
                      Formatos: JPG, PNG, GIF. La imagen se ajustara automaticamente al ancho del correo.
                    </p>
                  </div>

                  {/* Color de fondo */}
                  <div>
                    <label className="label">Color de Fondo</label>
                    <p className="text-sm text-gray-600 mb-2">
                      Selecciona el color de fondo del correo
                    </p>
                    <div className="flex items-center space-x-3">
                      <input
                        type="color"
                        value={messagingForm.emailBackgroundColor}
                        onChange={(e) => setMessagingForm({...messagingForm, emailBackgroundColor: e.target.value})}
                        className="h-10 w-20 rounded cursor-pointer border border-gray-300"
                      />
                      <input
                        type="text"
                        value={messagingForm.emailBackgroundColor}
                        onChange={(e) => setMessagingForm({...messagingForm, emailBackgroundColor: e.target.value})}
                        className="input-field flex-1"
                        placeholder="#F3F4F6"
                        pattern="^#[0-9A-Fa-f]{6}$"
                      />
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                      Formato hexadecimal (ejemplo: #F3F4F6)
                    </p>
                  </div>

                  {/* Vista previa / Nota */}
                  <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-blue-800">Diseno compatible con todos los clientes de correo</h4>
                        <p className="mt-1 text-sm text-blue-700">
                          El diseno personalizado esta optimizado para verse correctamente en Gmail, Outlook, Apple Mail y otros clientes de correo.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Firma del Email */}
            <div className="border-t border-gray-200 pt-4 mt-4">
              <div className="mb-4">
                <h4 className="text-md font-semibold">Firma del Correo</h4>
                <p className="text-sm text-gray-600 mt-1">
                  Agrega una firma personalizada al final del correo electronico
                </p>
              </div>

              <div className="space-y-4">
                {/* Tipo de firma */}
                <div>
                  <label className="label">Tipo de Firma</label>
                  <select
                    value={messagingForm.emailSignatureType}
                    onChange={(e) => setMessagingForm({...messagingForm, emailSignatureType: e.target.value})}
                    className="input-field"
                    disabled={!messagingForm.emailEnabled}
                  >
                    <option value="none">Sin firma</option>
                    <option value="text">Firma de texto</option>
                    <option value="image">Firma con imagen</option>
                  </select>
                </div>

                {/* Firma de texto */}
                {messagingForm.emailSignatureType === 'text' && messagingForm.emailEnabled && (
                  <div className="pl-4 border-l-4 border-green-200">
                    <label className="label">Texto de la Firma</label>
                    <textarea
                      value={messagingForm.emailSignatureText}
                      onChange={(e) => setMessagingForm({...messagingForm, emailSignatureText: e.target.value})}
                      className="input-field"
                      rows="4"
                      placeholder="Saludos,&#10;Equipo de Eventos&#10;contacto@ejemplo.com"
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      El texto sera mostrado al final del correo. Puedes usar saltos de linea.
                    </p>
                  </div>
                )}

                {/* Firma con imagen */}
                {messagingForm.emailSignatureType === 'image' && messagingForm.emailEnabled && (
                  <div className="pl-4 border-l-4 border-purple-200">
                    <label className="label">Imagen de la Firma</label>
                    <p className="text-sm text-gray-600 mb-2">
                      Sube una imagen para usar como firma (Recomendado: maximo 400px de ancho, 2MB maximo)
                    </p>

                    {messagingForm.emailSignatureImage && !emailSignatureFile && (
                      <div className="mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-700 mb-2">Imagen actual:</p>
                        <img
                          src={messagingForm.emailSignatureImage}
                          alt="Firma actual"
                          className="max-w-full h-auto rounded border border-gray-300"
                          style={{ maxHeight: '100px' }}
                        />
                      </div>
                    )}

                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleEmailSignatureFileChange}
                      className="input-field"
                    />

                    {emailSignatureFile && (
                      <p className="text-sm text-green-600 mt-1">
                        Nueva imagen seleccionada: {emailSignatureFile.name}
                      </p>
                    )}

                    <p className="text-sm text-gray-500 mt-1">
                      Formatos: JPG, PNG, GIF. La imagen se mostrara centrada en el correo.
                    </p>
                  </div>
                )}

                {/* Nota sobre responsive */}
                {messagingForm.emailEnabled && (
                  <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-green-800">Diseno responsive para moviles</h4>
                        <p className="mt-1 text-sm text-green-700">
                          Todos los correos estan optimizados para verse perfectamente en dispositivos moviles, tablets y computadoras.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h4 className="text-sm font-medium text-yellow-800">Configuracion de correo necesaria</h4>
                  <div className="mt-1 text-sm text-yellow-700">
                    <p>Asegurate de tener configuradas las variables de entorno para el envio de correos:</p>
                    <ul className="list-disc ml-5 mt-1">
                      <li>EMAIL_HOST (ejemplo: smtp.gmail.com)</li>
                      <li>EMAIL_PORT (ejemplo: 587)</li>
                      <li>EMAIL_USER (tu correo)</li>
                      <li>EMAIL_PASSWORD (contraseña de aplicacion)</li>
                      <li>EMAIL_FROM (remitente)</li>
                      <li>BACKEND_PUBLIC_URL (URL publica del backend)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={loading}
            className="btn-primary"
          >
            {loading ? 'Guardando...' : 'Guardar Configuracion'}
          </button>
        </div>
      </form>

      {/* Nota de configuración de Twilio */}
      <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">Configuracion de Twilio requerida</h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>Para usar esta funcionalidad, necesitas configurar Twilio en las variables de entorno del servidor:</p>
              <ul className="list-disc ml-5 mt-2">
                <li>TWILIO_ACCOUNT_SID</li>
                <li>TWILIO_AUTH_TOKEN</li>
                <li>TWILIO_PHONE_NUMBER (para SMS)</li>
                <li>TWILIO_WHATSAPP_NUMBER (para WhatsApp)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagingTab;
